// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Select__pc_only___3ZrVr","sp_only":"Select__sp_only___239Lq","select":"Select__select___1IdGr"};